module.exports = __webpack_public_path__ + "static/media/twitter-icon.00035c25.svg";